module.exports = __webpack_public_path__ + "img/830b8cf.png";